import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class StandardQuestionsSubCategories extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'StandardQuestionsSubCategories'
  // Define default properties here
  static instanceDefaults () {
    return {
      subCategoryId: null,
      standardQuestionId: null,
      isEnabled: true,
    }
  }
}
const servicePath = 'standard-questions-sub-categories'
const servicePlugin = makeServicePlugin({
  Model: StandardQuestionsSubCategories,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
